// extracted by mini-css-extract-plugin
export default {"colorTextLabel":"X1-z","colorTextValue":"Y1-z","swatches":"Z1-z","collapseLink":"_1-z","isCollapsed":"a2-z","dropdown":"b2-z","disabled":"c2-z"};